import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getCrops(companyId, cashedPayload, query) {
	// cashedPayload = [key, hash]
	return dataTransferWrap(
		ModulesMap.CROPS,
		dtConfig[ModulesMap.CROPS].getCrops,
		{
			urlParams: {
				companyId: companyId,
			},
			params: query,
		},
		cashedPayload
	)
}

function getBasedCrops(companyId, cashedPayload, query) {
	return dataTransferWrap(
		ModulesMap.CROPS,
		dtConfig[ModulesMap.CROPS].getBasedCrops,
		{
			urlParams: {
				companyId: companyId,
			},
			params: query,
		},
		cashedPayload
	)
}

function getExtendedCrops(companyId, cashedPayload, query) {
	return dataTransferWrap(
		ModulesMap.CROPS,
		dtConfig[ModulesMap.CROPS].getExtendedCrops,
		{
			urlParams: {
				companyId: companyId,
			},
			params: query,
		},
		cashedPayload
	)
}

function getCropPreview(companyId, cropsId, query) {
	return dataTransferWrap(
		ModulesMap.CROPS,dtConfig[ModulesMap.CROPS].getCropPreview, {
		urlParams: {
			companyId,
			cropsId,
		},
		params: query,
	})
}

function getCropPopup(companyId, cropsId, query) {
	return dataTransferWrap(
		ModulesMap.CROPS,dtConfig[ModulesMap.CROPS].getCropPopup, {
		urlParams: {
			companyId,
			cropsId,
		},
		params: query,
	})
}

function createCrop(companyId, data) {
	return dataTransferWrap(
		ModulesMap.CROPS,dtConfig[ModulesMap.CROPS].createCrop, {
		urlParams: {
			companyId,
		},
		...data,
	})
}

function getCrop(companyId, cropsId, query) {
	return dataTransferWrap(
		ModulesMap.CROPS,dtConfig[ModulesMap.CROPS].getCrop, {
		urlParams: {
			companyId,
			cropsId,
		},
		params: query,
	})
}

function patchCrop(companyId, cropsId, data) {
	return dataTransferWrap(
		ModulesMap.CROPS,dtConfig[ModulesMap.CROPS].patchCrop, {
		urlParams: {
			companyId,
			cropsId,
		},
		...data,
	})
}

function putCrop(companyId, cropsId, data) {
	return dataTransferWrap(
		ModulesMap.CROPS,dtConfig[ModulesMap.CROPS].putCrop, {
		urlParams: {
			companyId,
			cropsId,
		},
		...data,
	})
}

function deleteCrop(companyId, cropsId) {
	return dataTransferWrap(
		ModulesMap.CROPS,dtConfig[ModulesMap.CROPS].deleteCrop, {
		urlParams: {
			companyId,
			cropsId,
		},
	})
}

export default {
	getCrops,
	getBasedCrops,
	getExtendedCrops,
	getCropPopup,
	getCropPreview,
	createCrop,
	getCrop,
	patchCrop,
	putCrop,
	deleteCrop,
}
